// Dictionnaire de traductions injecte par sections/quiz-produit.liquid.
// Repli sur un objet vide : une cle absente rend `undefined` plutot que de
// casser tout le quiz sur une ReferenceError.
var JL_T = (typeof window !== 'undefined' && window.JL_T) || {};

    (function init() {
      var section = document.querySelector('.qp-section');
      if (!section) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        }
        return;
      }

      var N8N_WEBHOOK        = 'https://n8n.jacquelineslab.com/webhook/004ea279-358e-46d1-abc2-4bc0908a8045';
      var N8N_EMAIL_CLIENT   = 'https://n8n.jacquelineslab.com/webhook/quiz-email-client';
      /* Klaviyo écrit en direct depuis le navigateur (API client publique) — la partie
         Shopify (tag + note) est gérée côté serveur par le workflow n8n derrière
         N8N_EMAIL_CLIENT (voir plus bas). */
      var KLAVIYO_COMPANY_ID    = 'XN2zhp';
      /* Liste « prospects » — déclencheur de « FLUX - leads (all - list) » (32 emails,
         activé). Source : mapping_klaviyo_flows_n8n_enrichi + guide de référence §10.7. */
      var KLAVIYO_LIST_PROSPECTS = 'WtxhF4';

      /* Poids fermé Petit/Moyen/Grand (spec multi-chiens) : demandé directement au maître
         via la question `poids_chien`, posée dans toutes les branches. Les ids des options
         SONT les valeurs envoyées à Klaviyo — casse exacte, aucune variante (les flows
         Klaviyo existants filtrent sur ces 3 chaînes). */
      function derivePoidsChien() {
        return (state.answers.poids_chien || [])[0] || '';
      }

      /* Mapping recommandation → propriété Klaviyo `produit_interesse` (valeurs imposées
         par les flows leads existants — distinctes des libellés produits internes, où
         `multi` s'affiche « Soutien 360° »). */
      var PRODUIT_INTERESSE = {
        mobility:  JL_T["mobilite"],
        digestion: 'Digestion',
        multi:     'Multivitamines'
      };

      // ── Q1 : toujours identique ──────────────────────────────────
      /* Icônes (tracés Lucide — style line pro, cohérent) affichées sur la Q1 */
      var QP_ICONS = {
        activity: '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
        waves: '<path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>',
        sparkles: '<path d="M12 3l1.9 5.8a2 2 0 0 0 1.3 1.3L21 12l-5.8 1.9a2 2 0 0 0-1.3 1.3L12 21l-1.9-5.8a2 2 0 0 0-1.3-1.3L3 12l5.8-1.9a2 2 0 0 0 1.3-1.3z"/>',
        moon: '<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z"/>',
        heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z"/>'
      };

      var q1 = {
        id: 'concern',
        type: 'multi',
        max: 3,
        layout: 'list',
        title: JL_T["cette_semaine_tu_as_remarque_quoi_chez_lui"],
        help: JL_T["tu_peux_selectionner_jusqu_a_3_reponses"],
        options: [
          {
            id: 'mobility',
            icon: 'activity',
            title: JL_T["il_se_leve_un_peu_plus_lentement_qu_avant"],
            description: JL_T["il_a_deja_des_raideurs_ou_sa_race_y_est_pr"],
            micro: JL_T["beaucoup_de_maitres_attentifs_remarquent_c"],
            scores: { digestion: 0, mobility: 3, multi: 0 }
          },
          {
            id: 'digestion',
            icon: 'waves',
            title: JL_T["son_ventre_travaille_beaucoup"],
            description: JL_T["gaz_selles_molles_digestion_capricieuse_il"],
            micro: JL_T["c_est_souvent_le_premier_signal_que_quelqu"],
            scores: { digestion: 3, mobility: 0, multi: 0 }
          },
          {
            id: 'coat',
            icon: 'sparkles',
            title: JL_T["son_poil_a_change_moins_brillant_qu_avant"],
            description: JL_T["poil_terne_defenses_qui_baissent_vitalite"],
            micro: JL_T["un_signe_visible_d_un_desequilibre_nutriti"],
            scores: { digestion: 0, mobility: 0, multi: 3 }
          },
          {
            id: 'stress',
            icon: 'moon',
            title: JL_T["il_est_moins_enthousiaste_plus_dans_sa_bul"],
            description: JL_T["il_stresse_en_voiture_leche_excessivement"],
            micro: JL_T["le_comportement_est_souvent_le_reflet_de_c"],
            scores: { digestion: 2, mobility: 0, multi: 1 }
          },
          {
            id: 'prevent',
            icon: 'heart',
            title: JL_T["il_va_bien_je_veux_que_ca_reste_comme_ca"],
            description: JL_T["agir_avant_les_premiers_signaux_pour_qu_il"],
            micro: JL_T["c_est_exactement_l_etat_d_esprit_qui_chang"],
            scores: { digestion: 1, mobility: 2, multi: 2 }
          }
        ]
      };

      // ── Questions par branche ────────────────────────────────────
      var branchQuestions = {
        mobility: [
          {
            id: 'q2_mobility',
            type: 'single',
            layout: 'grid',
            title: JL_T["il_a_quel_age"],
            help: JL_T["ses_besoins_ne_sont_pas_les_memes_a_2_ans"],
            options: [
              { id: 'young', title: JL_T["moins_de_3_ans"], description: JL_T["poser_de_bonnes_bases_des_maintenant"], scores: { digestion: 0, mobility: 1, multi: 2 } },
              { id: 'adult', title: JL_T["entre_3_et_7_ans"], description: JL_T["dans_la_fleur_de_l_age_a_entretenir"], scores: { digestion: 0, mobility: 2, multi: 1 } },
              { id: 'senior', title: JL_T["plus_de_7_ans"], description: JL_T["senior_a_soutenir_activement"], scores: { digestion: 0, mobility: 3, multi: 1 } }
            ]
          }
          /* L'ancienne question « Sa morphologie, c'est plutôt ? » a été remplacée par la
             question de poids (buildPoidsQuestion), désormais posée dans toutes les branches. */
        ],
        digestion: [
          {
            id: 'q2_digestion',
            type: 'single',
            layout: 'list',
            title: JL_T["comment_ca_se_passe_au_moment_des_repas"],
            help: JL_T["chaque_comportement_alimentaire_nous_dit_q"],
            options: [
              { id: 'fast_eater', title: JL_T["il_mange_tres_vite_souvent_trop"], description: JL_T["sa_digestion_est_sous_pression_a_chaque_re"], scores: { digestion: 3, mobility: 0, multi: 0 } },
              { id: 'picky', title: JL_T["il_est_capricieux_refuse_certains_jours"], description: JL_T["des_inconforts_digestifs_peuvent_expliquer"], scores: { digestion: 2, mobility: 0, multi: 1 } },
              { id: 'stress_eating', title: JL_T["il_stresse_facilement_voiture_visiteurs_br"], description: JL_T["le_stress_chronique_perturbe_directement_s"], scores: { digestion: 3, mobility: 0, multi: 1 } },
              { id: 'recent_change', title: JL_T["ca_a_change_recemment_sans_raison_evidente"], description: JL_T["un_signe_que_son_equilibre_digestif_est_fr"], scores: { digestion: 2, mobility: 0, multi: 1 } }
            ]
          },
          {
            id: 'q3_digestion',
            type: 'single',
            layout: 'grid',
            title: JL_T["depuis_combien_de_temps_tu_observes_ca"],
            help: JL_T["la_duree_nous_aide_a_comprendre_si_c_est_p"],
            options: [
              { id: 'days', title: 'Quelques jours', description: '', scores: { digestion: 2, mobility: 0, multi: 0 } },
              { id: 'weeks', title: 'Quelques semaines', description: '', scores: { digestion: 3, mobility: 0, multi: 0 } },
              { id: 'months', title: 'Plusieurs mois', description: '', scores: { digestion: 3, mobility: 0, multi: 1 } },
              { id: 'always', title: JL_T["c_est_sa_nature_depuis_toujours"], description: '', scores: { digestion: 2, mobility: 0, multi: 2 } }
            ]
          }
        ],
        coat: [
          {
            id: 'q2_coat',
            type: 'single',
            layout: 'list',
            title: JL_T["son_alimentation_c_est_plutot"],
            help: JL_T["ce_qu_il_mange_chaque_jour_determine_ce_qu"],
            options: [
              { id: 'standard_kibble', title: 'Croquettes standard', description: JL_T["couverture_nutritionnelle_souvent_insuffis"], scores: { digestion: 0, mobility: 0, multi: 3 } },
              { id: 'premium_kibble', title: JL_T["alimentation_premium_ou_veterinaire"], description: 'Bonne base, mais certains besoins restent non couverts', scores: { digestion: 0, mobility: 0, multi: 2 } },
              { id: 'barf', title: JL_T["barf_ou_fait_maison"], description: JL_T["alimentation_vivante_mais_les_equilibres_s"], scores: { digestion: 0, mobility: 1, multi: 2 } },
              { id: 'mixed', title: JL_T["je_melange_plusieurs_choses"], description: '', scores: { digestion: 0, mobility: 0, multi: 2 } }
            ]
          },
          {
            id: 'q3_coat',
            type: 'single',
            layout: 'list',
            title: JL_T["dans_3_mois_tu_veux_voir_quoi_chez_lui"],
            help: JL_T["ce_que_tu_veux_pour_lui_oriente_ce_dont_il"],
            options: [
              { id: 'shiny_coat', title: JL_T["son_poil_brille_il_a_l_air_en_pleine_forme"], description: '', scores: { digestion: 0, mobility: 0, multi: 3 } },
              { id: 'more_playful', title: JL_T["il_est_plus_joueur_plus_present_avec_moi"], description: '', scores: { digestion: 0, mobility: 0, multi: 2 } },
              { id: 'immunity', title: JL_T["ses_defenses_sont_renforcees"], description: '', scores: { digestion: 0, mobility: 0, multi: 3 } },
              { id: 'longevity', title: JL_T["juste_qu_il_soit_encore_la_en_forme_longte"], description: '', scores: { digestion: 0, mobility: 1, multi: 2 } }
            ]
          }
        ],
        prevent: [
          {
            id: 'q2_prevent',
            type: 'single',
            layout: 'list',
            title: JL_T["avec_lui_tu_te_reconnais_dans_quoi"],
            help: JL_T["ton_rapport_a_sa_sante_nous_aide_a_trouver"],
            options: [
              { id: 'label_reader', title: JL_T["je_surveille_ce_qu_il_mange_je_lis_les_eti"], description: '', scores: { digestion: 1, mobility: 1, multi: 2 } },
              { id: 'attentive', title: JL_T["je_remarque_vite_quand_quelque_chose_chang"], description: '', scores: { digestion: 1, mobility: 2, multi: 1 } },
              { id: 'already_tried', title: JL_T["je_lui_donne_deja_des_complements_mais_je"], description: '', scores: { digestion: 1, mobility: 1, multi: 2 } },
              { id: 'just_starting', title: JL_T["je_commence_a_m_interesser_a_sa_sante"], description: '', scores: { digestion: 1, mobility: 1, multi: 2 } }
            ]
          },
          {
            id: 'q3_prevent',
            type: 'single',
            layout: 'list',
            title: JL_T["dans_3_mois_tu_veux_voir_quoi_chez_lui"],
            help: JL_T["ce_que_tu_veux_pour_lui_oriente_ce_dont_il"],
            options: [
              { id: 'no_stiffness', title: JL_T["il_se_leve_sans_raideur_le_matin"], description: '', scores: { digestion: 0, mobility: 3, multi: 0 } },
              { id: 'calm_gut', title: JL_T["son_ventre_est_calme_ses_selles_regulieres"], description: '', scores: { digestion: 3, mobility: 0, multi: 0 } },
              { id: 'shiny', title: JL_T["son_poil_brille_il_rayonne"], description: '', scores: { digestion: 0, mobility: 0, multi: 3 } },
              { id: 'longevity', title: JL_T["juste_qu_il_soit_encore_la_en_forme_longte"], description: '', scores: { digestion: 1, mobility: 1, multi: 2 } }
            ]
          }
        ]
      };

      var branchStats = {
        mobility: "9 propriétaires sur 10 avec un profil similaire ont remarqué une différence chez leur chien en moins de 4 semaines.",
        digestion: "91% des chiens ont vu leur confort digestif s'améliorer en 3 semaines avec DigeZyme®, notre complexe enzymatique breveté.",
        coat:      "1 chien sur 3 nourri aux croquettes standard présente des carences en vitamines B sans que ça se voie immédiatement.",
        prevent:   JL_T["les_maitres_qui_agissent_avant_les_premier"],
        multi:     "8 propriétaires sur 10 ayant observé plusieurs signaux ont choisi le Pack Complet. 94% l'ont renouvelé."
      };

      // ── Base de faits par branche ────────────────────────────────

      /* Écran science allégé : le chiffre sort de la phrase et devient l'image.
         Mêmes données que branchStats ci-dessus, découpées pour la mise en page. */
      var branchHeadline = {
        mobility:  { fig: '9',  sur: '/10', txt: JL_T["proprietaires_avec_un_profil_proche_ont_vu"] },
        digestion: { fig: '91', sur: '%',   txt: JL_T["des_chiens_ont_vu_leur_confort_digestif_s"] },
        coat:      { fig: '1',  sur: '/3',  txt: JL_T["des_chiens_nourris_aux_croquettes_standard"] },
        prevent:   { fig: '60', sur: '%',   txt: JL_T["de_risque_articulaire_en_moins_avant_8_ans"] },
        multi:     { fig: '8',  sur: '/10', txt: JL_T["maitres_ayant_observe_plusieurs_signaux_on"] }
      };

      var factsDB = {
        digestion: [
          { icon: '🔬', text: JL_T["60_des_chiens_souffrant_de_troubles_digest"] },
          { icon: '🧠', text: JL_T["70_du_systeme_immunitaire_de_ton_chien_est"] }
        ],
        mobility: [
          { icon: '📊', text: JL_T["les_articulations_de_nombreux_chiens_se_fr"] },
          { icon: '⚡', text: JL_T["a_chaque_saut_les_hanches_d_un_grand_chien"] }
        ],
        coat: [
          { icon: '💡', text: JL_T["1_chien_sur_3_presente_une_carence_en_vita"] },
          { icon: '🛡️', text: JL_T["un_poil_terne_est_presque_toujours_le_prem"] }
        ],
        stress: [
          { icon: '🧬', text: JL_T["40_des_comportements_compulsifs_lechage_ex"] },
          { icon: '⏱️', text: JL_T["un_episode_de_stress_intense_suffit_a_desy"] }
        ],
        prevent: [
          { icon: '🎯', text: JL_T["de_nombreux_desequilibres_articulations_di"] },
          { icon: '📈', text: JL_T["les_chiens_recevant_une_supplementation_ci"] }
        ]
      };

      function buildMultiQ2(concerns) {
        var concernLabels = {
          mobility: JL_T["il_se_leve_plus_lentement_qu_avant"],
          digestion: JL_T["son_ventre_travaille_beaucoup"],
          coat: JL_T["son_poil_a_change"],
          stress: JL_T["il_est_moins_enthousiaste"],
          prevent: JL_T["il_va_bien_je_veux_que_ca_reste_comme_ca"]
        };
        var concernScores = {
          mobility: { digestion: 0, mobility: 3, multi: 0 },
          digestion: { digestion: 3, mobility: 0, multi: 0 },
          coat: { digestion: 0, mobility: 0, multi: 3 },
          stress: { digestion: 2, mobility: 0, multi: 1 },
          prevent: { digestion: 1, mobility: 2, multi: 2 }
        };
        return [
          {
            id: 'q2_priority',
            type: 'single',
            layout: 'list',
            title: JL_T["sur_lequel_tu_veux_agir_en_priorite"],
            help: JL_T["choisis_le_signal_qui_t_inquiete_le_plus_p"],
            options: concerns.map(function(c) {
              return { id: c, title: concernLabels[c] || c, description: '', scores: concernScores[c] || { digestion: 1, mobility: 1, multi: 1 } };
            })
          },
          {
            id: 'q3_type',
            type: 'single',
            layout: 'list',
            title: JL_T["tu_es_plutot_quel_type_de_maitre"],
            help: "",
            options: [
              { id: 'reactive', title: JL_T["j_agis_des_que_je_remarque_quelque_chose"], description: '', scores: { digestion: 1, mobility: 1, multi: 1 } },
              { id: 'researcher', title: JL_T["je_prends_le_temps_de_chercher_ce_qui_est"], description: '', scores: { digestion: 1, mobility: 1, multi: 1 } },
              { id: 'simple', title: JL_T["je_veux_de_la_simplicite_que_ca_rentre_dan"], description: '', scores: { digestion: 1, mobility: 1, multi: 1 } },
              { id: 'investor', title: JL_T["je_suis_pret_a_investir_si_c_est_prouve_et"], description: '', scores: { digestion: 1, mobility: 1, multi: 1 } }
            ]
          }
        ];
      }

      /* Question de poids — dernière étape de toutes les branches. Les ids sont les valeurs
         exactes attendues par Klaviyo (Petit / Moyen / Grand).
         Seule la branche mobilité la fait peser dans le score : elle y remplace l'ancienne
         question morphologie et en reprend le barème. Ailleurs, elle sert uniquement à
         collecter la donnée — scores neutres, pour ne pas déplacer les recommandations
         existantes de ces branches. */
      function buildPoidsQuestion(branch) {
        var NEUTRAL = { digestion: 0, mobility: 0, multi: 0 };
        var scores = branch === 'mobility'
          ? {
              Petit: { digestion: 0, mobility: 1, multi: 1 },
              Moyen: { digestion: 0, mobility: 1, multi: 1 },
              Grand: { digestion: 0, mobility: 3, multi: 0 }
            }
          : { Petit: NEUTRAL, Moyen: NEUTRAL, Grand: NEUTRAL };

        return {
          id: 'poids_chien',
          type: 'single',
          layout: 'list',
          title: JL_T["son_poids_environ"],
          help: JL_T["sa_taille_influence_directement_la_sollici"],
          options: [
            { id: 'Petit', title: '1 à 10 kg',     description: 'Chihuahua, Yorkshire, Teckel...', scores: scores.Petit },
            { id: 'Moyen', title: '11 à 30 kg',    description: 'Cocker, Border Collie, Beagle...', scores: scores.Moyen },
            { id: 'Grand', title: JL_T["plus_de_30_kg"], description: 'Labrador, Golden, Berger...',      scores: scores.Grand }
          ]
        };
      }


      var productMeta = window.JL_QP_META || {};

      /* Le quiz démarre directement sur la Q1 (choix visuels) — le prénom est demandé à la fin, en option */
      var state = { step: 0, dogName: 'ton chien', branch: null, answers: {}, inFactMode: false, dynamicSteps: [] };
      /* Nombre d'étapes variable selon la branche : Q1 + questions de branche + poids.
         Tant que la branche n'est pas connue (Q1), on affiche la valeur la plus courante (3). */
      function totalSteps() {
        return state.dynamicSteps.length ? 1 + state.dynamicSteps.length : 3;
      }

      // ── Détermine la branche après Q1 ───────────────────────────
      function getBranch() {
        var concerns = getSelection('concern');
        if (concerns.length >= 2) return 'multi';
        if (concerns.indexOf('mobility')  !== -1) return 'mobility';
        if (concerns.indexOf('digestion') !== -1) return 'digestion';
        if (concerns.indexOf('stress')    !== -1) return 'digestion';
        if (concerns.indexOf('coat')      !== -1) return 'coat';
        return 'prevent';
      }

      function setDynamicSteps() {
        var branch = state.branch;
        var steps = branch === 'multi'
          ? buildMultiQ2(getSelection('concern'))
          : (branchQuestions[branch] || branchQuestions.prevent);
        state.dynamicSteps = steps.concat([buildPoidsQuestion(branch)]);
      }

      var dogNameStepEl    = section.querySelector('[data-dog-name-step]');
      var dogNameInputEl   = section.querySelector('[data-dog-name-input]');
      var dogNameNextBtn   = section.querySelector('[data-dog-name-next]');
      var titleEl             = section.querySelector('[data-question-title]');
      var helpEl              = section.querySelector('[data-question-help]');
      var optionsEl           = section.querySelector('[data-options]');
      var progressLabelEl     = section.querySelector('[data-progress-label]');
      var progressBarEl       = section.querySelector('[data-progress-bar]');
      var progressTrackEl     = section.querySelector('.qp-progress-track');

      /* Progression en segments : on voit combien d'étapes restent, pas un
         pourcentage. Purement visuel — aucune donnée n'en dépend. */
      function paintProgress(done, total) {
        if (!progressTrackEl) return;
        progressTrackEl.innerHTML = '';
        for (var i = 0; i < total; i++) {
          var seg = document.createElement('span');
          var cls = 'qp-progress-seg';
          if (i + 1 <= Math.floor(done)) cls += ' is-done';
          else if (i < done) cls += ' is-half';
          seg.className = cls;
          progressTrackEl.appendChild(seg);
        }
      }
      var selectionNoteEl     = section.querySelector('[data-selection-note]');
      var prevBtn             = section.querySelector('[data-prev]');
      var nextBtn             = section.querySelector('[data-next]');
      var resultEl            = section.querySelector('[data-result]');
      var resultTitleEl       = section.querySelector('[data-result-title]');
      var resultBodyEl        = section.querySelector('[data-result-body]');
      var resultWhyEl         = section.querySelector('[data-result-why]');
      var resultSecondaryEl   = section.querySelector('[data-result-secondary]');
      var resultPrimaryLinkEl = section.querySelector('[data-result-primary-link]');
      var resultSecondaryLinkEl = section.querySelector('[data-result-secondary-link]');
      var primaryInput          = section.querySelector('[data-quiz-primary-input]');
      var secondaryInput        = section.querySelector('[data-quiz-secondary-input]');
      var dognameInput          = section.querySelector('[data-quiz-dogname-input]');
      var branchInput           = section.querySelector('[data-quiz-branch-input]');
      var factStepEl            = section.querySelector('[data-fact-step]');
      var factTitleEl           = section.querySelector('[data-fact-title]');
      var factStatEl            = section.querySelector('[data-fact-stat]');
      var factsListEl           = section.querySelector('[data-facts-list]');
      var factContinueBtn       = section.querySelector('[data-fact-continue]');
      var bodyEl                = section.querySelector('.qp-body');
      var progressEl            = section.querySelector('.qp-progress');

      function getStepData() {
        if (state.step === 0) return q1;
        return state.dynamicSteps[state.step - 1];
      }
      function getSelection(id)        { return state.answers[id] || []; }
      function setSelection(id, vals)  { state.answers[id] = vals; }
      function isAnswered(step) {
        var s = getSelection(step.id);
        return Array.isArray(s) && s.length > 0;
      }

      // ── Étape prénom ─────────────────────────────────────────────
      function showDogNameStep() {
        var ackEl = section.querySelector('[data-dog-name-ack]');
        if (ackEl) {
          var picked = getSelection('concern');
          var lbl = q1.options.filter(function(o){ return picked.indexOf(o.id) !== -1; })
                             .map(function(o){ return o.title; })[0];
          if (lbl) { ackEl.textContent = lbl + JL_T["c_est_note"]; ackEl.classList.remove('qp-hidden'); }
          else ackEl.classList.add('qp-hidden');
        }
        dogNameStepEl.classList.add('is-visible');
        bodyEl.classList.add('qp-hidden');
        progressEl.classList.add('qp-hidden');
        prevBtn.classList.add('qp-hidden');
        nextBtn.classList.add('qp-hidden');
      }
      function hideDogNameStep() {
        dogNameStepEl.classList.remove('is-visible');
        bodyEl.classList.remove('qp-hidden');
        progressEl.classList.remove('qp-hidden');
        prevBtn.classList.remove('qp-hidden');
        nextBtn.classList.remove('qp-hidden');
      }

      if (dogNameNextBtn) {
        dogNameNextBtn.addEventListener('click', function() {
          var val = dogNameInputEl ? dogNameInputEl.value.trim() : '';
          /* 'ton chien' reste le repli exact d'origine : Klaviyo s'en sert pour
             ne PAS écrire prenom_chien quand le maître n'a rien saisi. */
          state.dogName = val || 'ton chien';
          state.nameAsked = true;
          hideDogNameStep();
          showFactStep();
        });
      }
      if (dogNameInputEl) {
        /* Le prénom s'affiche en dessous à la frappe : la personnalisation se
           prouve au lieu de s'annoncer. */
        var dogEchoEl = section.querySelector('[data-dog-name-echo]');
        dogNameInputEl.addEventListener('input', function() {
          if (!dogEchoEl) return;
          var v = dogNameInputEl.value.trim();
          dogEchoEl.innerHTML = v ? JL_T["le_bilan_de"] + v.replace(/[<>&]/g, '') + '</strong>' : '';
        });
        dogNameInputEl.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { dogNameNextBtn && dogNameNextBtn.click(); }
        });
      }

      // ── Rendu des options ────────────────────────────────────────
      /* Habillage en cartes pour les deux questions chiffrées. La borne est
         portée par un mot (« jusqu'à », « de 11 à ») plutôt que par un tiret
         ou un « < », qui se lisent comme des maths.
         Les clés sont les ids d'options EXACTS — casse comprise pour le poids,
         que les flows Klaviyo filtrent sur Petit/Moyen/Grand. */
      var CARD_FACES = {
        poids_chien: {
          Petit: { pre: JL_T["jusqu_a"], fig: '10', unit: 'kg' },
          Moyen: { pre: JL_T["de_11_a"], fig: '30', unit: 'kg' },
          Grand: { pre: 'plus de', fig: '30', unit: 'kg' }
        },
        q2_mobility: {
          nolabel: true,
          young:  { pre: 'moins de', fig: '3', unit: 'ans' },
          adult:  { pre: JL_T["de_3_a"],   fig: '7', unit: 'ans' },
          senior: { pre: 'plus de',  fig: '7', unit: 'ans' }
        }
      };

      function cardMarkup(step, option) {
        var set  = CARD_FACES[step.id] || {};
        var face = set[option.id];
        if (!face) return null;
        var dogs = window.JL_QP_DOGS || {};
        var dog  = step.id === 'poids_chien' ? dogs[option.id] : '';
        var sizes = { Petit: 52, Moyen: 74, Grand: 100 };
        return [
          dog ? '<span class="qp-card-dog"><img src="' + dog + '" alt="" aria-hidden="true" loading="lazy" style="width:' + (sizes[option.id] || 74) + '%"></span>' : '',
          '<span class="qp-card-pre">', face.pre, '</span>',
          '<span class="qp-card-fig">', face.fig, '<span class="qp-card-unit">', face.unit, '</span></span>',
          (option.description && !set.nolabel) ? '<span class="qp-card-label">' + option.description + '</span>' : ''
        ].join('');
      }

      function renderOptions(step) {
        optionsEl.innerHTML = '';
        var asCards = !!CARD_FACES[step.id];
        optionsEl.setAttribute('data-layout', asCards ? 'cards' : (step.layout === 'grid' ? 'grid' : 'list'));
        var selected = getSelection(step.id);
        step.options.forEach(function(option) {
          var isSel = selected.indexOf(option.id) !== -1;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qp-option' + (isSel ? ' is-selected' : '') + (asCards ? ' qp-option--card' : '');
          btn.setAttribute('data-option-id', option.id);

          if (asCards) {
            var card = cardMarkup(step, option);
            if (card) {
              btn.innerHTML = card;
              btn.addEventListener('click', function() { toggleOption(step, option); });
              optionsEl.appendChild(btn);
              return;
            }
          }
          var descHtml = option.description ? '<span class="qp-option-desc">' + option.description + '</span>' : '';
          var iconHtml = (option.icon && QP_ICONS[option.icon])
            ? '<span class="qp-option-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + QP_ICONS[option.icon] + '</svg></span>'
            : '';
          btn.innerHTML = [
            iconHtml,
            '<span class="qp-option-indicator" aria-hidden="true">',
              '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">',
                '<path d="M3.4 8.2l2.2 2.2 5-5.1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
              '</svg>',
            '</span>',
            '<span class="qp-option-copy">',
              '<span class="qp-option-title">', option.title, '</span>',
              descHtml,
            '</span>'
          ].join('');
          btn.addEventListener('click', function() { toggleOption(step, option); });
          optionsEl.appendChild(btn);
        });
      }

      function updateSelectionNote(step, selected) {
        if (step.type === 'multi') {
          selectionNoteEl.textContent = selected.length === 0
            ? JL_T["selectionne_jusqu_a"] + step.max + JL_T["reponses"]
            : selected.length + JL_T["reponse"] + (selected.length > 1 ? 's' : '') + JL_T["selectionnee"] + (selected.length > 1 ? 's' : '') + ' sur ' + step.max + '.';
        } else {
          selectionNoteEl.textContent = selected.length > 0 ? JL_T["choix_enregistre"] : JL_T["choisis_une_reponse_pour_continuer"];
        }
      }

      function toggleOption(step, option) {
        var optionId = option.id;
        var selected = getSelection(step.id).slice();
        var index    = selected.indexOf(optionId);
        if (step.type === 'multi') {
          if (index !== -1) selected.splice(index, 1);
          else { if (selected.length >= step.max) return; selected.push(optionId); }
        } else {
          selected = index !== -1 ? [] : [optionId];
        }
        setSelection(step.id, selected);

        // Micro-validation sur Q1
        if (step.id === 'concern' && option.micro && index === -1) {
          selectionNoteEl.textContent = option.micro;
          selectionNoteEl.style.color = 'var(--qp-primary)';
          selectionNoteEl.style.fontStyle = 'italic';
          setTimeout(function() {
            selectionNoteEl.style.color = '';
            selectionNoteEl.style.fontStyle = '';
            updateSelectionNote(step, getSelection(step.id));
          }, 2200);
        } else {
          updateSelectionNote(step, getSelection(step.id));
        }

        // Mise à jour visuelle des boutons sans re-render complet
        var allOpts = optionsEl.querySelectorAll('[data-option-id]');
        var sel = getSelection(step.id);
        allOpts.forEach(function(el) {
          el.classList.toggle('is-selected', sel.indexOf(el.getAttribute('data-option-id')) !== -1);
        });
        nextBtn.disabled = !isAnswered(step);
      }

      // ── Scores & ranking ─────────────────────────────────────────
      function computeScores() {
        var totals = { digestion: 0, mobility: 0, multi: 0 };
        var allSteps = [q1].concat(state.dynamicSteps);
        allSteps.forEach(function(step) {
          getSelection(step.id).forEach(function(id) {
            var opt = step.options.filter(function(o) { return o.id === id; })[0];
            if (!opt) return;
            totals.digestion += opt.scores.digestion || 0;
            totals.mobility  += opt.scores.mobility  || 0;
            totals.multi     += opt.scores.multi     || 0;
          });
        });
        return totals;
      }

      function computeRanking() {
        var scores = computeScores();
        // Bonus gabarit pour la branche mobilité (hérité de l'ancienne question morphologie)
        if (state.branch === 'mobility' && derivePoidsChien() === 'Grand') scores.mobility += 2;
        return Object.keys(scores).map(function(k) {
          return { key: k, score: scores[k] };
        }).sort(function(a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return ['digestion','mobility','multi'].indexOf(a.key) - ['digestion','mobility','multi'].indexOf(b.key);
        });
      }

      // ── Texte "pourquoi lui" ─────────────────────────────────────
      function buildWhyText(primaryKey) {
        var concerns = getSelection('concern');
        var lines = [];
        if (primaryKey === 'digestion') {
          if (concerns.indexOf('digestion') !== -1) lines.push(JL_T["son_ventre_perturbe_est_exactement_ce_qu_a"]);
          if (concerns.indexOf('stress') !== -1) lines.push(JL_T["le_stress_perturbe_directement_son_microbi"]);
          if (!lines.length) lines.push(JL_T["un_microbiote_equilibre_c_est_un_chien_apa"]);
        } else if (primaryKey === 'mobility') {
          if (concerns.indexOf('mobility') !== -1) lines.push(JL_T["ses_articulations_t_inquietent_c_est_le_bo"]);
          if (!lines.length) lines.push(JL_T["des_articulations_soutenues_des_maintenant"]);
        } else {
          if (concerns.indexOf('coat') !== -1) lines.push(JL_T["un_pelage_terne_signale_souvent_une_carenc"]);
          if (!lines.length) lines.push(JL_T["un_soutien_complet_pour_qu_il_rayonne_beau"]);
        }
        return lines.slice(0, 2).join(' ');
      }

      // ── Étape faits (interstitielle après Q1) ────────────────────
      function showFactStep() {
        state.inFactMode = true;
        state.branch = getBranch();
        setDynamicSteps();

        var branch = state.branch;
        var branchFacts = factsDB[branch] || factsDB.prevent;
        var stat = branchStats[branch] || '';

        if (factTitleEl) factTitleEl.textContent = JL_T["tu_as_bien_fait_de_le_remarquer"];

        /* Le chiffre porte le message, la phrase l'accompagne. branchStats reste
           le repli si une branche n'a pas d'entrée dédiée. */
        var head = branchHeadline[branch];
        var figEl = section.querySelector('[data-fact-figure]');
        if (head && figEl) {
          figEl.innerHTML = head.fig + '<span class="qp-fact-figure__sur">' + head.sur + '</span>';
          figEl.classList.remove('qp-hidden');
          if (factStatEl) factStatEl.innerHTML = head.txt;
        } else {
          if (figEl) figEl.classList.add('qp-hidden');
          if (factStatEl) factStatEl.textContent = stat;
        }

        /* Un seul fait : deux paragraphes de plus après le chiffre, personne ne
           les lit. Le second reste dans factsDB pour les emails. */
        factsListEl.innerHTML = branchFacts.slice(0, 1).map(function(f) {
          return '<p class="qp-fact-text">' + f.text + '</p>';
        }).join('');

        var displayName = state.dogName !== 'ton chien' ? state.dogName : 'lui';
        if (factContinueBtn) factContinueBtn.textContent = "C'est exactement " + displayName + ". Je continue";

        bodyEl.classList.add('qp-hidden');
        factStepEl.classList.remove('qp-hidden');
        progressLabelEl.textContent = JL_T["ce_que_ca_signifie"];
        /* Écran intercalé entre l'étape 1 et l'étape 2 → segment à moitié rempli */
        paintProgress(1.5, totalSteps());
        prevBtn.classList.add('qp-hidden');
        nextBtn.classList.add('qp-hidden');
      }

      function hideFactStep() {
        state.inFactMode = false;
        bodyEl.classList.remove('qp-hidden');
        factStepEl.classList.add('qp-hidden');
        prevBtn.classList.remove('qp-hidden');
        nextBtn.classList.remove('qp-hidden');
      }

      if (factContinueBtn) {
        factContinueBtn.addEventListener('click', function() {
          hideFactStep();
          state.step = 1;
          render();
        });
      }

      // ── Affichage résultat ───────────────────────────────────────
      function showResult() {
        var ranking   = computeRanking();
        var primary   = ranking[0];
        var secondary = ranking[1];
        var meta      = productMeta[primary.key];
        var name      = state.dogName;

        /* recommandation réellement calculée (digestion/mobility/multi) — distincte de
           state.branch, qui ne sert qu'au routage des questions et peut valoir 'coat'
           ou 'prevent' (absents de productMeta). C'est primary.key qu'il faut envoyer
           à Klaviyo/Shopify/n8n pour que la donnée corresponde à la vraie recommandation. */
        state.primaryKey = primary.key;

        // Titre personnalisé avec le prénom
        resultTitleEl.textContent = JL_T["voila_ce_que"] + name + ' ne pouvait pas te dire.';
        resultBodyEl.textContent  = meta.description;

        /* Sa réponse à « Dans 3 mois, tu veux voir quoi chez lui ? », renvoyée
           mot pour mot. Elle est déjà collectée aujourd'hui et n'était jamais
           réutilisée. Lecture seule — le payload n'en est pas modifié. */
        var echoEl = section.querySelector('[data-result-echo]');
        if (echoEl) {
          var voeu = '';
          state.dynamicSteps.forEach(function(st) {
            if (!st || !st.title || st.title.indexOf('3 mois') === -1) return;
            var pick = getSelection(st.id)[0];
            (st.options || []).forEach(function(o) { if (o.id === pick) voeu = o.title; });
          });
          if (voeu) {
            /* Citation, pas de phrase enchâssée : les titres d'options n'ont
               pas tous la même forme (« Son poil brille », « Juste : qu'il
               soit encore là »), aucune tournure ne les accueille tous
               proprement. On rend ses mots tels quels. */
            echoEl.innerHTML = JL_T["ce_que_tu_veux_dans_3_mois"]
                             + '<span class="qp-result-echo__quote">' + voeu + '</span>';
            echoEl.classList.remove('qp-hidden');
          } else {
            echoEl.classList.add('qp-hidden');
          }
        }

        // Chips profil
        var profileEl = section.querySelector('[data-result-profile]');
        if (profileEl) {
          var branchLabel = { mobility: 'Articulations', digestion: 'Digestion', coat: JL_T["vitalite"], prevent: JL_T["prevention"], multi: 'Bilan complet' };
          var chips = [name !== 'ton chien' ? name : ''].filter(Boolean);
          if (state.branch) chips.push(branchLabel[state.branch] || '');
          profileEl.innerHTML = chips.map(function(c) {
            return '<span class="qp-profile-chip">' + c + '</span>';
          }).join('');
        }

        var ingredientsEl = section.querySelector('[data-result-ingredients]');
        if (ingredientsEl && meta.ingredients) {
          ingredientsEl.innerHTML = meta.ingredients.map(function(ing) {
            return '<span class="qp-ingredient-pill"><img class="qp-ingredient-photo" src="' + ing.photo + '" alt="" loading="lazy" width="28" height="28">' + ing.label + '</span>';
          }).join('');
        }

        if (resultWhyEl) resultWhyEl.textContent = buildWhyText(primary.key);

        /* Le bouton passe par /discount/QUIZ10 : Shopify pose le code en session au
           passage, puis redirige vers la fiche produit. La personne arrive au même
           endroit qu'avant, mais n'a plus rien à recopier au paiement.
           Le code reste affiché à l'écran et dans l'email pour qui préfère le noter. */
        resultPrimaryLinkEl.setAttribute('href', '/discount/QUIZ10?redirect=' + encodeURIComponent(meta.anchor));
        resultPrimaryLinkEl.textContent = JL_T["je_commence_avec"] + meta.name + ' (abonnement -15%)';
        /* Marqueur lu par la fiche produit pour confirmer que la remise est bien posée.
           Shopify efface la query string du redirect, d'où le passage par la session. */
        resultPrimaryLinkEl.onclick = function() {
          try { sessionStorage.setItem('jl_promo_quiz', 'QUIZ10'); } catch (e) {}
        };
        if (primaryInput) primaryInput.value = meta.name;
        if (dognameInput) dognameInput.value  = state.dogName;
        if (branchInput)  branchInput.value   = state.branch || '';

        var imgEl = section.querySelector('[data-result-product-img]');
        var lnkEl = section.querySelector('[data-result-product-link]');
        if (imgEl) { imgEl.src = meta.image; imgEl.alt = 'Formule ' + meta.name; }
        if (lnkEl) { lnkEl.setAttribute('href', meta.anchor); }

        /* Nom de la formule prioritaire, affiché en titre de la carte n°1 */
        var recoNameEl = section.querySelector('[data-reco-name]');
        if (recoNameEl) recoNameEl.textContent = meta.name;

        var recoSecondEl = section.querySelector('[data-reco-second]');
        if (secondary && secondary.score > 0 && secondary.key !== primary.key) {
          var sec = productMeta[secondary.key];
          if (recoSecondEl) recoSecondEl.classList.remove('qp-hidden');
          resultSecondaryEl.classList.remove('qp-hidden');
          resultSecondaryEl.innerHTML = '<strong>' + sec.name + JL_T["beaucoup_de_maitres_associent_les_deux"];
          resultSecondaryLinkEl.classList.remove('qp-hidden');
          resultSecondaryLinkEl.setAttribute('href', sec.anchor);
          resultSecondaryLinkEl.textContent = 'Voir ' + sec.name;
          if (secondaryInput) secondaryInput.value = sec.name;
        } else {
          if (recoSecondEl) recoSecondEl.classList.add('qp-hidden');
          resultSecondaryEl.classList.add('qp-hidden');
          resultSecondaryLinkEl.classList.add('qp-hidden');
          if (secondaryInput) secondaryInput.value = '';
        }

        /* Les trois arguments de décision. La dose vient du dosage imprimé sur
           les sachets (1 / 2 / 3 bouchées selon le gabarit) : c'est la preuve
           la plus concrète que le bilan a servi à quelque chose. Le délai
           reprend le chiffre de la branche, déjà affiché à l'écran science. */
        var DOSES = { Petit: '1 bouchée', Moyen: '2 bouchées', Grand: '3 bouchées' };
        var poids = derivePoidsChien();
        var doseEl  = section.querySelector('[data-fact-dose]');
        var delaiEl = section.querySelector('[data-fact-delai]');
        if (doseEl) {
          doseEl.innerHTML = DOSES[poids]
            ? JL_T["sa_dose"] + DOSES[poids] + JL_T["par_jour_calculee_sur_son_gabarit"]
            : JL_T["une_a_trois_bouchees_par_jour_selon_son_ga"];
        }
        if (delaiEl) {
          var head = branchHeadline[state.branch];
          delaiEl.innerHTML = head
            ? '<strong>' + head.fig + head.sur + JL_T["des_maitres_voient_une_difference_en_moins"]
            : JL_T["les_premiers_effets_s_observent_en_moins_d"];
        }

        var emailCta = section.querySelector('.qp-unlock-cta');
        if (emailCta) {
          emailCta.textContent = name && name !== 'ton chien'
            ? JL_T["ou_on_envoie_le_bilan_de"] + name + ' ?'
            : JL_T["ou_on_envoie_son_bilan"];
        }
        var lockedTitle = section.querySelector('[data-locked-title]');
        if (lockedTitle) {
          lockedTitle.innerHTML = name && name !== 'ton chien'
            ? JL_T["le_bilan_de_2"] + name + JL_T["et_son_code_10"]
            : JL_T["son_bilan_complet_et_son_code_10"];
        }

        var finalNameEl = section.querySelector('.qp-final-dogname');
        if (finalNameEl && name && name !== 'ton chien') {
          finalNameEl.value = name;
          finalNameEl.classList.add('qp-hidden');
        }

        resultEl.classList.add('is-visible');
        resultEl.classList.add('is-locked');

        // Notification silencieuse vers n8n
        try {
          var quizNotifPayload = {
            /* Clé normalisée — identique aux line item properties Shopify et à Klaviyo (spec multi-chiens) */
            prenom_chien:   state.dogName,
            branche:        state.branch,
            recommandation: primary.key,
            reponses:       state.answers,
            timestamp:      new Date().toISOString(),
            source:         'quiz-homepage'
          };
          var quizPoidsChien = derivePoidsChien();
          if (quizPoidsChien) quizNotifPayload.poids_chien = quizPoidsChien;
          fetch(N8N_WEBHOOK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(quizNotifPayload)
          }).catch(function() {});
        } catch(e) {}
      }

      function hideResult() { resultEl.classList.remove('is-visible'); }

      // ── Render ───────────────────────────────────────────────────
      function render() {
        if (state.step < 0) { showDogNameStep(); return; }

        var step     = getStepData();
        if (!step) return;
        var selected = getSelection(step.id);
        var answered = isAnswered(step);
        var total    = totalSteps();
        var progress = ((state.step + 1) / total) * 100;

        titleEl.textContent = step.title;
        helpEl.textContent  = step.help || '';
        progressLabelEl.textContent = JL_T["etape"] + (state.step + 1) + ' / ' + total;
        paintProgress(state.step + 1, total);

        updateSelectionNote(step, selected);

        prevBtn.disabled = state.step === 0;
        nextBtn.disabled = !answered;
        nextBtn.textContent = state.step === total - 1 ? 'Voir ma recommandation' : 'Continuer';

        renderOptions(step);
        hideResult();
      }

      // ── Navigation ───────────────────────────────────────────────
      prevBtn.addEventListener('click', function() {
        if (state.step <= 0) return;
        state.step -= 1;
        render();
      });

      nextBtn.addEventListener('click', function() {
        var step = getStepData();
        if (!isAnswered(step)) return;

        if (state.step === 0) {
          /* Le prénom s'intercale ici : après le premier clic, avant l'écran
             science — qui l'utilise déjà (« C'est exactement Gaspard »). */
          if (dogNameStepEl && !state.nameAsked) { showDogNameStep(); return; }
          showFactStep();
          return;
        }

        if (state.step === totalSteps() - 1) {
          showResult();
          nextBtn.disabled = true;
          prevBtn.disabled = false;
          return;
        }

        state.step += 1;
        render();
      });

      var restartBtn = section.querySelector('[data-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', function() {
          state.step = 0;
          state.dogName = 'ton chien';
          state.branch = null;
          state.answers = {};
          state.dynamicSteps = [];
          state.inFactMode = false;
          hideFactStep();
          hideResult();
          nextBtn.disabled = true;
          prevBtn.disabled = true;
          if (dogNameInputEl) dogNameInputEl.value = '';
          render();
          section.querySelector('[data-quiz-root]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      // ── Email client → n8n ──────────────────────────────────────
      var emailForm = section.querySelector('.qp-email-form');
      if (emailForm) {
        /* ── Pourquoi on neutralise la soumission native ──
           Shopify greffe un captcha invisible sur les formulaires Liquid (tag form)
           (ce_storefront_forms_captcha_hcaptcha). Quand il a fini de valider,
           il RESOUMET le formulaire lui-même via form.submit() — la méthode
           native, qui ignore preventDefault et ne déclenche aucun événement
           'submit'. Notre gestionnaire annulait bien la soumission de l'utilisateur,
           puis le captcha renvoyait tout vers /contact un demi-seconde plus tard :
           la page repartait sur ?customer_posted=true, en haut de la home, en
           plein milieu de la lecture du bilan.
           Ce formulaire n'est jamais censé partir en POST : l'email est envoyé
           en fetch vers n8n et Klaviyo, et c'est n8n qui crée le client Shopify
           côté serveur.

           Le blocage est posé sur le PROTOTYPE, pas sur l'instance : Google Ads,
           GA4 et le pixel Facebook remplacent chacun HTMLFormElement.prototype.submit
           pour tracer les soumissions, et le captcha passe par cette chaîne — un
           form.submit = function(){} sur l'objet lui-même était contourné.
           Les formulaires concernés sont marqués par un data-attribut ; tous les
           autres formulaires du site gardent leur comportement normal. */
        emailForm.dataset.jlNoNativeSubmit = '1';
        if (!HTMLFormElement.prototype.__jlSubmitGuard) {
          var submitNatif = HTMLFormElement.prototype.submit;
          HTMLFormElement.prototype.submit = function () {
            if (this && this.dataset && this.dataset.jlNoNativeSubmit) return;
            return submitNatif.apply(this, arguments);
          };
          HTMLFormElement.prototype.__jlSubmitGuard = true;
        }
        emailForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var emailInput = emailForm.querySelector('input[type="email"]');
          if (!emailInput || !emailInput.value) return;

          /* Prénom du chien saisi (optionnel) juste avant l'envoi — personnalise la fiche email */
          var finalDogName = emailForm.querySelector('.qp-final-dogname');
          if (finalDogName && finalDogName.value.trim()) {
            state.dogName = finalDogName.value.trim();
            if (dognameInput) dognameInput.value = state.dogName;
          }

          var submitBtn = emailForm.querySelector('.qp-email-submit');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Envoi…';
            /* Le bouton restait figé sur « … » indéfiniment. On lui rend un état
               lisible une fois l'envoi passé, au cas où la zone resterait visible. */
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = JL_T["voir_son_bilan"];
            }, 2500);
          }

          var quizEmailPoidsChien = derivePoidsChien();

          try {
            var emailClientPayload = {
              email:          emailInput.value,
              prenom_chien:   state.dogName,
              recommandation: state.primaryKey,
              code_promo:     'QUIZ10',
              timestamp:      new Date().toISOString(),
              /* Soumettre ce formulaire = demander la fiche par email : opt-in explicite,
                 cohérent avec le champ customer[accepts_marketing] du form Shopify.
                 n8n s'en sert pour l'abonnement Klaviyo et le consent Shopify. */
              consent:        true
            };
            if (quizEmailPoidsChien) emailClientPayload.poids_chien = quizEmailPoidsChien;
            fetch(N8N_EMAIL_CLIENT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(emailClientPayload)
            }).catch(function() {});
          } catch(err) {}

          /* Klaviyo (API client publique, aucune clé privée) — même pattern que
             page.evenement.liquid : le quiz est le seul moment où l'email du client
             est connu, donc c'est ici (et seulement ici) qu'on peut écrire le profil. */
          try {
            /* Noms de propriétés imposés par les flows Klaviyo existants — identiques à ceux
               écrits côté serveur par n8n, pour que les deux sources fusionnent sur le même
               profil au lieu de créer des propriétés parallèles. */
            var klaviyoProps = {
              produit_interesse: PRODUIT_INTERESSE[state.primaryKey] || '',
              source_lead:       'quiz'
            };
            /* 'ton chien' est le libellé de repli quand le prénom n'a pas été saisi —
               l'écrire dans Klaviyo polluerait les emails personnalisés. */
            if (state.dogName && state.dogName !== 'ton chien') klaviyoProps.prenom_chien = state.dogName;
            if (quizEmailPoidsChien) klaviyoProps.poids_chien = quizEmailPoidsChien;

            var klaviyoEmail = emailInput.value;

            /* Deux appels, dans cet ordre précis.

               1. /client/profiles/ écrit les propriétés — c'est produit_interesse qui
                  pilote tout le contenu adaptatif des templates.
               2. /client/subscriptions/ abonne le profil ET l'ajoute à la liste
                  « prospects », ce qui DÉCLENCHE le flow leads.

               Le second appel manquait entièrement : le lead était créé et abonné au
               marketing, mais n'entrait dans aucun flow, puisqu'un flow Klaviyo ne
               démarre que sur un ajout à une liste, un événement ou une entrée de
               segment. Le chaînage .then() garantit que les propriétés sont posées
               avant que le flow démarre — sinon le premier email adaptatif part dans
               sa branche « else » générique, sans produit ni prénom. */
            fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'revision': '2024-10-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'profile',
                  attributes: {
                    email: klaviyoEmail,
                    properties: klaviyoProps
                  }
                }
              })
            })
            .catch(function() {})
            .then(function() {
              return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'revision': '2024-10-15'
                },
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      custom_source: 'Quiz produit',
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: klaviyoEmail,
                            properties: klaviyoProps
                          }
                        }
                      }
                    },
                    relationships: {
                      list: { data: { type: 'list', id: KLAVIYO_LIST_PROSPECTS } }
                    }
                  }
                })
              });
            })
            .catch(function() {});
          } catch(err) {}

          /* Shopify (tag "quiz" + note enrichie) : déjà géré côté serveur par le workflow
             n8n derrière N8N_EMAIL_CLIENT lui-même (corrigé pour chercher/mettre à jour le
             client au lieu d'un simple "create" qui échouait pour les clients existants),
             donc aucun appel supplémentaire nécessaire ici. */

          // Révélation du code : retirer le flou
          var codeEl = section.querySelector('[data-code-display]');
          if (codeEl) {
            codeEl.classList.remove('qp-code-locked');
            codeEl.classList.add('qp-code-revealed');
          }

          // Le résultat se déverrouille
          if (resultEl) resultEl.classList.remove('is-locked');

          // Cacher la zone email, montrer le succès
          var emailZone = section.querySelector('[data-email-zone]');
          if (emailZone) emailZone.classList.add('qp-hidden');
          var successZone = section.querySelector('[data-success-zone]');
          if (successZone) successZone.classList.remove('qp-hidden');
        });
      }

      render();
    })();

/* ── Rituel scroll ── */
  (function(){
    var section = document.querySelector('.qp-section');
    if (!section) return;
    var r = section.querySelector('.qp-rituel');
    if (!r) return;
    var anchor = r.closest('.qp-visual-wrap') || section;
    function update(){
      var rect = anchor.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var start = vh * 0.88, end = vh * 0.42;
      var p = (start - rect.top) / (start - end);
      p = Math.max(0, Math.min(1, p));
      if (window.innerWidth <= 900) {
        /* mobile : glisse depuis la droite + fondu quand l'image arrive */
        r.style.opacity = p.toFixed(2);
        r.style.transform = 'translateX(' + (150 * (1 - p)).toFixed(1) + 'px)';
      } else {
        /* desktop : sort de derrière l'image vers la droite */
        r.style.opacity = '1';
        r.style.transform = 'translateX(' + (-180 * (1 - p)).toFixed(1) + 'px)';
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();
